import { memo } from 'react';

import { useTeamInterestCheck } from '../hooks/useTeamInterestCheck';

import Logged from './Logged';
import NotLogged from './NotLogged';

const TeamInRound = ({
  teamInterestId,
  roundId,
  logged,
}: {
  teamInterestId?: string;
  roundId?: string;
  logged: boolean;
}) => {
  const { team } = useTeamInterestCheck(teamInterestId, roundId);
  if (!team) return null;

  return logged ? <Logged /> : <NotLogged />;
};

export default memo(TeamInRound);
